__turbopack_context__.v({
  "gradientDrift": "workspaceAgentSpaceFabMark-module__iuYZ9q__gradientDrift",
});
